"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var HttpService_1 = require("../../utils/HttpService");
var BaseService = /** @class */ (function () {
    function BaseService(serviceConfig) {
        if (serviceConfig === void 0) { serviceConfig = {}; }
        this.headers = {};
        var baseURL = serviceConfig.baseURL, appInstance = serviceConfig.appInstance, revalidateAppInstance = serviceConfig.revalidateAppInstance;
        this.httpService = new HttpService_1.HttpService({
            baseURL: baseURL,
            appInstance: appInstance,
            revalidateAppInstance: revalidateAppInstance,
        });
    }
    // TODO: cover with test
    BaseService.prototype.setAppInstance = function (instance) {
        return this.httpService.setAppInstance(instance);
    };
    // TODO: cover with test
    BaseService.prototype.setRevalidateAppInstance = function (fn) {
        return this.httpService.setRevalidateAppInstance(fn);
    };
    BaseService.prototype.setBaseURL = function (baseURL) {
        this.httpService.setBaseURL(baseURL);
    };
    BaseService.prototype.setHeaders = function (headers) {
        this.headers = headers;
    };
    BaseService.prototype.request = function (requestConfig) {
        return this.httpService.request(__assign(__assign({}, requestConfig), { headers: this.headers }));
    };
    return BaseService;
}());
exports.BaseService = BaseService;
//# sourceMappingURL=index.js.map